// extracted by extract-css-chunks-webpack-plugin
module.exports = {"flex-center":"flex-center","ButtonIcon":"ButtonIcon","ButtonIcon--no-border":"ButtonIcon--no-border"};